import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('howie_service_area_review', '/howie_service_area_reviews', 'review')
const reducer = generator.generate()

export default reducer
